import Achievements from "../../components/achievements";
import AllCatagoryCard from "../../components/allCatagoryCard";
import AllCatagoryCrd from "../../components/allCatagoryCard";
import Button from "../../components/Button";
import CatagoryCard from "../../components/CatagoryCard";
import FavoritePlace from "../../components/favoritePlace";
import HeroPage from "../../components/HeroPage";
import ProductList from "../../components/featuredProductList";
import Tabs from "../../components/tab/tabs";
function Home() {
  const handleClick = () => {
    alert("Button clicked!");
  };
  return (
    <>
      <div className="space-y-24 ">
        <HeroPage />

        <AllCatagoryCard />
        <ProductList />
        <Achievements />

        <FavoritePlace />
      </div>
    </>
  );
}
export default Home;
